import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { UntypedFormArray, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ExternalLink } from './externalLink';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { swalMini } from '../../../../../../../shared/utils/utils';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'externalLink';

@Component({
    selector: 'app-external-link',
    templateUrl: './external-link.component.html',
    styleUrls: ['./external-link.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, CMSComponent, NextSelectorComponent]
})
export class ExternalLinkComponent extends NodeBuilder implements OnInit {

  externalLinkForm: UntypedFormGroup;
  logicForm: UntypedFormGroup;
  newStep = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    const externalLinkForms = ExternalLink.toForm(stepData, this.canEdit);
    this.externalLinkForm = externalLinkForms.ExternalLinkForm;
    this.logicForm = externalLinkForms.LogicForm;

    const results = this.logicForm.get('results') as UntypedFormArray;
    const defaultResult = results.at(0) as UntypedFormGroup;

    if (defaultResult.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep();
      defaultResult.get('next').setValue(this.newStep);
    }
  }

  get getStepData(): {} {
    const formData = this.externalLinkForm.getRawValue();
    const logicData = this.logicForm?.getRawValue();

    const nodeData = new ExternalLink().nodeData;
    nodeData['menu']['text'] = formData.text;
    nodeData['menu']['url'] = formData.url;

    const results = {};

    logicData.results.forEach(resultGroup => {
      results[resultGroup.result] = {
        next: resultGroup.next,
        description: resultGroup.description,
      };
    });
    nodeData['menu']['results'] = results;

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.externalLinkForm.markAllAsTouched();
    this.logicForm.markAllAsTouched();
    return this.externalLinkForm.valid && this.logicForm.valid;
  }

  public addResult(): void {
    const results: UntypedFormArray = this.logicForm.get('results') as UntypedFormArray;

    const newResultGroup = ExternalLink.buildResultGroup('', '', newStepValue, this.canEdit.canEditFlows);

    results.push(newResultGroup);
  }

  public deleteResult(controlName: string, index: number): void {
    const resultsArray: UntypedFormArray = this.logicForm.get(controlName) as UntypedFormArray;
    if (resultsArray.length > 1) {
      resultsArray.removeAt(index);
    } else {
      swalMini({
        title: 'At least one option needed',
        type: 'error',
      });
    }
  }
}
